// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_11-2";
export var blackBorderOnHover = "_11-7";
export var cell = "_11-6";
export var cellContainer = "_11-3";
export var checked = "_11-8";
export var disabled = "_11-5";
export var featuredIconCellContainer = "_11-9";
export var featuredIconTextContainer = "_11-b";
export var featuredIconWrapper = "_11-a";
export var noBorder = "_11-c";
export var orangeSelectedRow = "_1l-3";
export var overflowableText = "_11-0";
export var overflowableTextContainer = "_11-1";
export var row = "_12-0";
export var rowCheckboxCell = "_11-4";
export var selectableTable = "_1l-2";